import { Language } from '@dvinci/attract-studio-components'

export function convertMultilingualData(data: any, lang: Language): any {
  if (!data) return data

  // Create a deep copy to avoid modifying the original
  const result = JSON.parse(JSON.stringify(data))

  // Process all fields recursively
  Object.keys(result).forEach(key => {
    const value = result[key]

    // Skip null/undefined values
    if (value == null) return

    // Skip the language field if it exists
    if (key === 'language') return

    // If it's an object with language keys
    if (typeof value === 'object' && !Array.isArray(value) && (value.de !== undefined || value.en !== undefined)) {
      // Convert to string using current language or fallback to German
      result[key] = value[lang] || value.de || ''
    }
    // If it's a nested object or array, process recursively
    else if (typeof value === 'object') {
      result[key] = convertMultilingualData(value, lang)
    }
  })

  result.language = lang

  return result
}
